<template>
    <div v-if="!storeLocation?.isTempClosed && !storeLocation.storeStatus.isRedRobinStore" class="px-16">
        <h4 class="ion-text-center">This Donatos Offers</h4>
        <ion-row class="ion-justify-content-evenly" v-if="storeLocation?.displayOrderTypes">
            <ion-col v-for="type in storeLocation?.displayOrderTypes" :key="type.id">
                <ion-icon :aria-label="type.icon" :ios="type.icon" :md="type.icon" color="dark" />
                <p class="ion-no-margin small">{{ type.display }}</p>
            </ion-col>
        </ion-row>

        <ion-row class="ion-justify-content-evenly" v-else>
            <ion-col class="ion-text-center" size="2" v-for="i in Array(2)" :key="i">
                <dynamicSkeleText :childElements="[{ image: true }, { width: 85 }]" />
            </ion-col>
        </ion-row>
    </div>
    <div v-if="storeLocation.storeStatus.isRedRobinStore">
        <h4 class="ion-text-center">This Red Robin Offers Donatos</h4>
    </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { IonIcon, IonRow, IonCol } from '@ionic/vue';
import dynamicSkeleText from '@/components/dynamicSkeleText.vue';
import { StoreLocation } from '@/models/locationModels';

export default defineComponent({
    props: {
        storeLocation: {
            type: Object as PropType<StoreLocation>,
            required: true,
        },
    },
    components: { IonRow, IonCol, IonIcon, dynamicSkeleText },
});
</script>

<style scoped>
ion-icon {
    font-size: 3em;
}

h4 {
    color: var(--ion-color-dark);
}
</style>
